<div class="row m-b-xs" (dblclick)="editModeOn()">
    <div *ngIf="title"
         class="dv-label col-sm-3 strong"
         data-toggle="tooltip"
         data-placement="top"
         [title]="tooltipText">
        {{ title }}
    </div>

    <div *ngIf="!editOnly"
         class="dv-value col-sm-12" style="padding-top: 4px;"
         [ngClass]="{'hidden': isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">

        <span [class]="valueClass" style="font-size: 12px;">
            {{ getValueById(value) || other || '-' }}
        </span>

        <i *ngIf="!noEdit" (click)="editModeOn()"
           class="fa fa-pencil pull-right"
           data-toggle="tooltip"
           data-placement="top"
           title="Edit"></i>
    </div>

    <div class="dv-value-edit col-sm-12"
         [ngClass]="{'hidden': !isEditMode && !editOnly, 'col-sm-9': title, 'col-sm-12': !title}">
        <select class="form-control" [(ngModel)]="value">
            <option *ngIf="withOther" [value]="0">Other</option>
            <option *ngFor="let item of data" [value]="item.id">{{ item[optionTitleKey] }}</option>
        </select>

        <button *ngIf="!editOnly" (click)="apply()" type="button">
            <i class="fa fa-check"></i>
        </button>

        <button *ngIf="!editOnly" (click)="cancel()" type="button">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/select-field/select-field.template.html